import './client-mobile.scss';

import dayjs from 'dayjs';

import { type TDataSource } from '@/types/dataSource';

import { findFinancedOfferDate } from '../../../../helpers/findFinancedOfferDate';

type ClientMobileProps = {
  dataSource: TDataSource | undefined;
};

const ClientMobile = ({ dataSource }: ClientMobileProps) => {
  if (!dataSource) return null;

  return (
    <div className="client-requests-mobile">
      <p className="client-requests-mobile__info">
        <span className="client-requests-mobile__label">ID заявки:</span>{' '}
        <span>#{dataSource.client.code}</span>
      </p>

      <p className="client-requests-mobile__info">
        <span className="client-requests-mobile__label">Дата создания:</span>
        <span>{dayjs(dataSource?.created_at?.date).format('DD.MM.YYYY')}</span>
      </p>
      <p className="client-requests-mobile__info">
        <span className="client-requests-mobile__label">Стоимость авто:</span>
        <span>
          {dataSource.loan.amount ? `${dataSource.loan.amount} ₸` : '-'}
        </span>
      </p>
      <p className="client-requests-mobile__info">
        <span className="client-requests-mobile__label">Перв. взнос:</span>
        <span>
          {dataSource.loan.initialFee ? `${dataSource.loan.initialFee} ₸` : '-'}
        </span>
      </p>
      <p className="client-requests-mobile__info">
        <span className="client-requests-mobile__label">Срок займа:</span>
        <span>
          {dataSource.loan.loanTerm ? `${dataSource.loan.loanTerm} мес.` : '-'}
        </span>
      </p>
      <p className="client-requests-mobile__info">
        <span className="client-requests-mobile__label">
          Дата финансирования:
        </span>
        <span> {findFinancedOfferDate(dataSource.responses)}</span>
      </p>
    </div>
  );
};

export default ClientMobile;
